export default "__VITE_ASSET__CmFVKVRt__"